/**
 * Component: M3 Vertical Carousel
 * 
 */
'use strict';

export class VerticalCarousel
{
  constructor()
  {
    this.selectors = {
      component:          $('.c-v4-m3-vertical-carousel'),
      slider:             $('.c-v4-m3-vertical-carousel--main-content'),
      content:            $('.c-v4-m3-vertical-carousel--main-content-item > div'),
      content_item_last:  $('.c-v4-m3-vertical-carousel--main-content-item:last'),
      image_col:          $('.c-v4-m3-vertical-carousel--main-image'),
      images:             $('.c-v4-m3-vertical-carousel--main-image-item'),
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_vertical_carousel();
    this.init_slick_carousel();
  }

  /**
   * Init vertical scrolling carousel
   * 
   */
  init_vertical_carousel()
  {
    let _self = this;

    // Set image column height to active image
    $(window).on('load resize orientationchange', function()
    {
      let h = _self.selectors.images.toArray().reduce( function( prev, current )
      {
        return ( prev.clientHeight > current.clientHeight ) ? prev.clientHeight : current.clientHeight
      });

      _self.selectors.image_col.css('height', h); 
    });

    $(window).on('load scroll', function()
    {
      let index = null;

      // Set image column height to active image
      let h = _self.selectors.images.filter(function()
      {
        return $(this).hasClass('active');
      }).outerHeight();

      _self.selectors.image_col.css('height', h);

      // Get active index
      _self.selectors.content.each(function()
      {
        let h = $(this).offset().top - $(this).outerHeight();

        if ( ( $(this).offset().top < $(window).scrollTop() + 525 ) &&
          ( $(window).scrollTop() > h ) )
        {
          index = $(this).attr('data-slide');
        }
      });

      let current = _self.selectors.images.filter( function()
      {
        return $(this).hasClass('active');
      }).attr('data-slide');

      // Only toggle if index has changed
      if ( index != current ||
         ( index == 0 && current == 0 ) ||
         ( index === null && current === undefined ) )
      {
        let active_slide = _self.selectors.images.removeClass('active').filter(function()
        {
          if ( index === null )
          {
            return $(this).attr('data-slide') == 0;
          }
          else
          {
            return $(this).attr('data-slide') == index;
          }
        }).addClass('active');

        if ( active_slide && active_slide[0] )
        {
          let player = active_slide[0].querySelector('dotlottie-player');

          if ( player )
          {
            if ( active_slide && ( index != null && current != 0 ) )
            {
              player.stop();
              player.play();
            }
            else
            {
              player.play();
            }
          }
        }
      }
    });
  }

  /**
   * Init slick carousel
   *
   * Only displays on mobile
   * 
   */
  init_slick_carousel()
  {
    let _self = this;

    $(window).on('load resize orientationchange', function()
    {
      // Disable on desktop sizes
      if ( $(window).width() > 768 )
      {
        if ( _self.selectors.slider.hasClass('slick-initialized') )
        {
          _self.selectors.slider.slick('unslick');
        }
      }
      else
      {
        if ( ! _self.selectors.slider.hasClass('slick-initialized') )
        {
          _self.selectors.slider.slick({
            arrows:         false,
            dots:           true,
            mobileFirst:    true,
            infinite:       false,
            slidesToScroll: 1,
            slidesToShow:   1,
          });
        }
      }
    });
  }
}